module.exports = __webpack_public_path__ + "static/project-5-d54413630329d41f053fdcb05688df57.jpg";